import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@env/environment';
import { User } from '@app/models/user.model';
import { ConstantsService } from '@app/services/constants.service';
import * as CryptoJS from 'crypto-js';
import { user_status } from '@app/config/user-status.enum';
import { PROFILE_ACCESS, profile_access_module, role_name } from '@app/config/role-name.enum';
import { BehaviorSubject, catchError, map, Observable, of } from 'rxjs';
import { AppInjector } from '@app/app.module';
import { CryptoService } from './crypto.service';
import { status_code } from 'functions/src/help/status-query';
import { local_storage_key } from 'functions/src/help/local-storage-key';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private BASE_URL_SERVICE: string = environment.endpoint.apiuser;

  private cryptoService = AppInjector.get(CryptoService);

  public loginBehavior = new BehaviorSubject(this.getIdCurrentUser());
  public roleBehavior: BehaviorSubject<string> = new BehaviorSubject(null);
  public moduleActivateBehavior: BehaviorSubject<string> = new BehaviorSubject(null);

  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public isLoaded: boolean = false;

  constructor(private http: HttpClient,
    private router: Router,
    private constantsService: ConstantsService) {
  }


  savePreferences(req: any) {
    return this.http.post(this.BASE_URL_SERVICE + 'savePreference/', req);
  }

  savePreferenceEmployerJob(req: any) {
    return this.http.post(this.BASE_URL_SERVICE + 'savePreferenceEmployerJob/', req);
  }

  savePreferencesEmployer(req: any) {
    return this.http.post(this.BASE_URL_SERVICE + 'savePreferenceEmployer/', req);
  }

  getPreference(_idUser: any) {

    var req =
    {
      _idUser: _idUser
    }

    return this.http.post(this.BASE_URL_SERVICE + 'getPreference/', req);
  }


  getPreferenceEmployer(_idUser: any, module: any) {

    var req =
    {
      _idUser: _idUser,
      module: module
    }

    return this.http.post(this.BASE_URL_SERVICE + 'getPreferenceEmployer/', req);
  }

  getUserByEmployer(token: any) {
    return this.http.get<any>(this.BASE_URL_SERVICE + 'getUserByEmployer/' + `${token}`);
  }

  getPreferenceJob(_idUser: any, _idJob) {

    var req =
    {
      _idUser,
      _idJob
    }

    return this.http.post(this.BASE_URL_SERVICE + 'getPreferenceJob/', req);
  }


  getListUsersByEmployer(reqParam, isListAll: boolean) {

    let req = {
      idEmployer: reqParam.idEmployer,
      optionFilter: reqParam.optionFilter,
      optionStatus: reqParam.optionStatus,
      optionPage: reqParam.optionPage,
      optionListAll: isListAll
    };

    if (req.optionStatus === user_status.All) {
      req.optionStatus = "";
    }

    return this.http.post(this.BASE_URL_SERVICE + 'listUsersByEmployer/', req);
  }

  getSalaries(req) {

    return this.http.post<any>(this.BASE_URL_SERVICE + 'getSalaries/', req);
  }

  getSalariesPosition(req) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'getSalariesPosition/', req);
  }

  getSalaryAuth(_idUser: number, _idEmployee: number) {

    const req = { _idUser, _idEmployee }

    return this.http.post<any>(this.BASE_URL_SERVICE + `getSalaryAuth/`, req);
  }

  async postUser(user: User) {

    let req = {
      userEmail: user.userEmail,
      userPass: user.userPass,
      userStatus: user.userStatus,
      userProfile: user.userProfile
    };

    await this.http.post<any>(this.BASE_URL_SERVICE, req).toPromise().then(res => {
      console.log(res);
    },
      err => {
        console.error(err);
      }
    )
  }

  postUserByEmployer(user: User, idEmployer: any) {

    let req = {
      reqUser: {
        userEmail: user.userEmail,
        userPass: user.userPass,
        userStatus: user_status.Disabled,
        userProfile: role_name.Employer
      },
      reqEmployerUser: {
        userName: user.userName,
        userSurname: user.userSurname,
        userDNI: user.userDNI,
        userPhoneNumber: user.userPhoneNumber
      },
      idEmployer: idEmployer
    };



    return this.http.post<any>(this.BASE_URL_SERVICE + 'postUserByEmployer/', req);
  }

  saveUserByEmployer(_id: number, req: any) {

    if (_id > 0) {
      return this.http.put<any>(this.BASE_URL_SERVICE + `putUserEmployer/${_id}`, req);
    }
    else {
      return this.http.post<any>(this.BASE_URL_SERVICE + 'postUserEmployer/', req);
    }
  }

  deleteUser(idUser: any) {
    return this.http.delete<any>(this.BASE_URL_SERVICE + `deleteUser/${idUser}`);
  }

  sendVerifyMail(_id: number) {
    return this.http.post<any>(this.BASE_URL_SERVICE + `sendVerifyMail/`, { _id });
  }

  sendVerifyMailUserEmployer(_id: string) {

    var req =
    {
      _id: _id
    }

    return this.http.post<any>(this.BASE_URL_SERVICE + `sendVerifyMailUserEmployer/`, req);
  }

  sendCreatePassUserEmployer(_id: string, userEmail: string, userName: string) {

    var req =
    {
      _id: _id,
      userName,
      userEmail
    }

    return this.http.post<any>(this.BASE_URL_SERVICE + `sendCreatePassUserEmployer/`, req);
  }


  signInUser(params: any) {

    let req = {
      userEmail: params.userEmail,
      userPass: params.userPass,
      userProfile: params.userProfile,
      userStatus: user_status.Enabled
    };

    return this.http.post<any>(this.BASE_URL_SERVICE + 'signin/', req);
  }

  signInAdmin(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'signInAdmin/', req);
  }

  passwordRecovery(params: any) {

    let req = {
      userEmail: params.userEmail,
      userProfile: params.userProfile,
      userStatus: user_status.Enabled
    };

    return this.http.post<any>(this.BASE_URL_SERVICE + 'passwordRecovery/', req);
  }

  changePassword(params: any) {

    let req = {
      _idUser: params._idUser,
      userPassOld: params.userPassOld,
      userPassNew: params.userPassNew
    };

    return this.http.post<any>(this.BASE_URL_SERVICE + 'changePassword/', req);
  }

  resetPassword(params: any) {

    let req = {
      token: params.token,
      userPassNew: params.userPassNew
    };

    return this.http.post<any>(this.BASE_URL_SERVICE + 'resetPassword/', req);
  }

  linkedinLogin(code: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'linkedin/login/', { code: code });
  }

  googleLogin(email: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'google/login/', { email: email });
  }

  setPasswordAndConfirm(params: any) {

    let req = {
      token: params.token,
      userPassNew: params.userPassNew
    };

    return this.http.post<any>(this.BASE_URL_SERVICE + 'setPasswordAndConfirm/', req);
  }


  emailVerify(token: string) {

    let req = {
      token: token
    };

    return this.http.post<any>(this.BASE_URL_SERVICE + 'emailVerify/', req);
  }

  logOut(isRedirect: boolean) {//modificar : resetear variable currentUser

    localStorage.clear();

    this.loginBehavior.next(this.getIdCurrentUser());

    if (isRedirect === true) { this.router.navigate([this.constantsService.BASE_PATH_HOME]); }
  }

  loggedIn() {//modificar : obtener desde variable currentUser
    return !!localStorage.getItem(local_storage_key.token);
  }

  getIdCurrentUser() {//modificar : obtener desde variable currentUser
    try {
      return CryptoJS.AES.decrypt(localStorage.getItem(local_storage_key._idUser), local_storage_key.hash_encrypt).toString(CryptoJS.enc.Utf8);
    }
    catch {
      return '0';
    }
  }

  getCurrentEmailLogin() {//modificar : obtener desde variable currentUser
    return CryptoJS.AES.decrypt(localStorage.getItem(local_storage_key.email_login), local_storage_key.hash_encrypt).toString(CryptoJS.enc.Utf8);
  }

  getIdEmployer(): number {//modificar : obtener desde variable currentUser

    try {
      return parseInt(CryptoJS.AES.decrypt(localStorage.getItem(local_storage_key._idEmployer), local_storage_key.hash_encrypt).toString(CryptoJS.enc.Utf8));
    }
    catch {
      return 0;
    }
  }


  isAdmin() {//modificar : obtener desde variable currentUser
    return this.loggedIn() && CryptoJS.AES.decrypt(localStorage.getItem(local_storage_key.user_profile), local_storage_key.hash_encrypt).toString(CryptoJS.enc.Utf8) === role_name.Admin;
  }

  isAccountant() {//modificar : obtener desde variable currentUser
    return this.loggedIn() && CryptoJS.AES.decrypt(localStorage.getItem(local_storage_key.user_profile), local_storage_key.hash_encrypt).toString(CryptoJS.enc.Utf8) === role_name.Accountant;
  }

  isProspection() {//modificar : obtener desde variable currentUser
    return this.loggedIn() && CryptoJS.AES.decrypt(localStorage.getItem(local_storage_key.user_profile), local_storage_key.hash_encrypt).toString(CryptoJS.enc.Utf8) === role_name.Prospection;
  }

  isAdminEmployer() {//modificar : obtener desde variable currentUser
    return this.loggedIn() && CryptoJS.AES.decrypt(localStorage.getItem(local_storage_key.user_profile), local_storage_key.hash_encrypt).toString(CryptoJS.enc.Utf8) === role_name.AdminEmployer;
  }

  isEmployee() {//modificar : obtener desde variable currentUser
    return this.loggedIn() && CryptoJS.AES.decrypt(localStorage.getItem(local_storage_key.user_profile), local_storage_key.hash_encrypt).toString(CryptoJS.enc.Utf8) === role_name.Employee;
  }

  isEmployer() {//modificar : obtener desde variable currentUser
    return this.loggedIn() && (CryptoJS.AES.decrypt(localStorage.getItem(local_storage_key.user_profile), local_storage_key.hash_encrypt).toString(CryptoJS.enc.Utf8) === role_name.Employer);
  }

  getUserProfile() {
    if (!this.loggedIn()) return null;

    return CryptoJS.AES.decrypt(localStorage.getItem(local_storage_key.user_profile), local_storage_key.hash_encrypt).toString(CryptoJS.enc.Utf8);
  }

  getUserRole() {
    if (!this.loggedIn()) return null;

    try {
      return CryptoJS.AES.decrypt(localStorage.getItem(local_storage_key.user_role), local_storage_key.hash_encrypt).toString(CryptoJS.enc.Utf8);
    } catch {
      return '';
    }
  }

  getAccessComplaintChannel() {
    if (!this.loggedIn()) return null;

    try {
      return CryptoJS.AES.decrypt(localStorage.getItem(local_storage_key.access_complaint_channel), local_storage_key.hash_encrypt).toString(CryptoJS.enc.Utf8);
    } catch {
      return null;
    }
  }

  getAccessJobReference() {
    if (!this.loggedIn()) return null;

    try {
      return CryptoJS.AES.decrypt(localStorage.getItem(local_storage_key.access_job_reference), local_storage_key.hash_encrypt).toString(CryptoJS.enc.Utf8);
    } catch {
      return null;
    }
  }

  getUserName() {
    if (!this.loggedIn()) return null;

    return CryptoJS.AES.decrypt(localStorage.getItem(local_storage_key.user_name), local_storage_key.hash_encrypt).toString(CryptoJS.enc.Utf8);
  }

  getUserSurname() {
    if (!this.loggedIn()) return null;

    return CryptoJS.AES.decrypt(localStorage.getItem(local_storage_key.user_surname), local_storage_key.hash_encrypt).toString(CryptoJS.enc.Utf8);
  }

  getUserPhoto() {
    if (!this.loggedIn()) return null;

    if (!localStorage.getItem(local_storage_key.user_photo)) {
      return "";
    }
    return CryptoJS.AES.decrypt(localStorage.getItem(local_storage_key.user_photo), local_storage_key.hash_encrypt).toString(CryptoJS.enc.Utf8);

  }


  getUserPhone() {
    if (!this.loggedIn()) return null;

    if (!localStorage.getItem(local_storage_key.user_phone)) {
      return "";
    }
    return CryptoJS.AES.decrypt(localStorage.getItem(local_storage_key.user_phone), local_storage_key.hash_encrypt).toString(CryptoJS.enc.Utf8);

  }


  getIdEmployee() {
    if (!this.loggedIn()) return null;

    if (!localStorage.getItem(local_storage_key._idEmployee)) {
      return "";
    }
    return CryptoJS.AES.decrypt(localStorage.getItem(local_storage_key._idEmployee), local_storage_key.hash_encrypt).toString(CryptoJS.enc.Utf8);

  }

  getEmployerName(): any {
    if (!this.loggedIn()) return "";

    if (this.getUserProfile() !== role_name.Employer) return "";

    return CryptoJS.AES.decrypt(localStorage.getItem(local_storage_key.employer_name), local_storage_key.hash_encrypt).toString(CryptoJS.enc.Utf8);
  }

  getEmployerAllEmployees(): boolean {
    if (!this.loggedIn()) return false;

    if (this.getUserProfile() !== role_name.Employer) return false;

    try {
      return +CryptoJS.AES.decrypt(localStorage.getItem(local_storage_key.login_all_employees), local_storage_key.hash_encrypt).toString(CryptoJS.enc.Utf8) === 1;
    }
    catch {
      return false;
    }
  }



  //deuda tecnica
  setLocaleStorageSignIn(
    _idUser: string,
    userEmail: string,
    userProfile: string,
    userName: string,
    token: string,
    refreshtoken: string,
  ) {

    localStorage.setItem(local_storage_key._idUser, CryptoJS.AES.encrypt(_idUser.toString().trim(), local_storage_key.hash_encrypt).toString());
    localStorage.setItem(local_storage_key.email_login, CryptoJS.AES.encrypt(userEmail.toString().trim(), local_storage_key.hash_encrypt).toString());
    localStorage.setItem(local_storage_key.user_profile, CryptoJS.AES.encrypt(userProfile.toString().trim(), local_storage_key.hash_encrypt).toString());
    localStorage.setItem(local_storage_key.user_name, CryptoJS.AES.encrypt(userName.toString().trim(), local_storage_key.hash_encrypt).toString());

    this.setLocalJWT(token);

    this.setLocalRefreshJWT(refreshtoken);

    this.loginBehavior.next(this.getIdCurrentUser());

    //deuda tecnica
    localStorage.setItem(local_storage_key._idEmployee, CryptoJS.AES.encrypt('0', local_storage_key.hash_encrypt).toString());
    localStorage.setItem(local_storage_key._idEmployer, CryptoJS.AES.encrypt('0', local_storage_key.hash_encrypt).toString());
    localStorage.setItem(local_storage_key.user_surname, CryptoJS.AES.encrypt('', local_storage_key.hash_encrypt).toString());
    localStorage.setItem(local_storage_key.user_photo, CryptoJS.AES.encrypt('', local_storage_key.hash_encrypt).toString());
    localStorage.setItem(local_storage_key.user_phone, CryptoJS.AES.encrypt('', local_storage_key.hash_encrypt).toString());
    localStorage.setItem(local_storage_key.employer_name, CryptoJS.AES.encrypt('', local_storage_key.hash_encrypt).toString());
    localStorage.setItem(local_storage_key.token, CryptoJS.AES.encrypt(local_storage_key.token, local_storage_key.hash_encrypt).toString());
  }

  setLocalStorageLogin(token: string, refreshtoken: string, emailLogin: string, idUser: string, idEmployee: string, userProfile: string, userRole: string, userName: string, userSurname: string, userPhoto: string, userPhone: string, userEventFlag: number) {

    localStorage.setItem(local_storage_key._idUser, CryptoJS.AES.encrypt(idUser?.toString().trim(), local_storage_key.hash_encrypt).toString());
    this.loginBehavior.next(this.getIdCurrentUser());
    localStorage.setItem(local_storage_key.email_login, CryptoJS.AES.encrypt(emailLogin?.toString().trim(), local_storage_key.hash_encrypt).toString());
    localStorage.setItem(local_storage_key.user_profile, CryptoJS.AES.encrypt(userProfile?.toString().trim(), local_storage_key.hash_encrypt).toString());
    localStorage.setItem(local_storage_key.user_role, CryptoJS.AES.encrypt(userRole?.toString().trim(), local_storage_key.hash_encrypt).toString());
    localStorage.setItem(local_storage_key.user_name, CryptoJS.AES.encrypt(userName?.toString().trim(), local_storage_key.hash_encrypt).toString());
    localStorage.setItem(local_storage_key.user_surname, CryptoJS.AES.encrypt(userSurname?.toString().trim(), local_storage_key.hash_encrypt).toString());

    if (userPhoto) {
      localStorage.setItem(local_storage_key.user_photo, CryptoJS.AES.encrypt(userPhoto?.toString().trim(), local_storage_key.hash_encrypt).toString());
    }

    if (userPhone) {
      localStorage.setItem(local_storage_key.user_phone, CryptoJS.AES.encrypt(userPhone?.toString().trim(), local_storage_key.hash_encrypt).toString());
    }

    localStorage.setItem(local_storage_key.token, CryptoJS.AES.encrypt(token, local_storage_key.hash_encrypt).toString());
    localStorage.setItem(local_storage_key._idEmployee, CryptoJS.AES.encrypt(idEmployee?.toString(), local_storage_key.hash_encrypt).toString());
    localStorage.setItem(local_storage_key.user_event_flag, CryptoJS.AES.encrypt(userEventFlag?.toString(), local_storage_key.hash_encrypt).toString());

    this.setLocalJWT(token);

    this.setLocalRefreshJWT(refreshtoken);
  }

  setLocalUserRole(userRole: string, triggerBehavior: boolean = true) {

    const currentUserRole = this.getUserRole();

    if (userRole !== currentUserRole) {
      localStorage.setItem(local_storage_key.user_role, CryptoJS.AES.encrypt(userRole?.toString().trim(), local_storage_key.hash_encrypt).toString());
      if (triggerBehavior)
        this.roleBehavior.next(userRole);
    }
  }

  setLocalAccessComplaintChannel(access: string, triggerBehavior: boolean = true) {

    const currentAccess = this.getAccessComplaintChannel();

    if (access !== currentAccess) {
      localStorage.setItem(local_storage_key.access_complaint_channel, CryptoJS.AES.encrypt(access?.toString().trim(), local_storage_key.hash_encrypt).toString());
      if (triggerBehavior)
        this.moduleActivateBehavior.next(access);
    }
  }

  setLocalAccessJobReference(access: string, triggerBehavior: boolean = true) {

    const currentAccess = this.getAccessJobReference();

    if (access !== currentAccess) {
      localStorage.setItem(local_storage_key.access_job_reference, CryptoJS.AES.encrypt(access?.toString().trim(), local_storage_key.hash_encrypt).toString());
      if (triggerBehavior)
        this.moduleActivateBehavior.next(access);
    }
  }

  setCurrentSessionName(idEmployee) {
    localStorage.setItem(local_storage_key._idEmployee, CryptoJS.AES.encrypt(idEmployee.toString(), local_storage_key.hash_encrypt).toString());
  }

  setUserPhoto(photo: any) {
    if (photo) {
      localStorage.setItem(local_storage_key.user_photo, CryptoJS.AES.encrypt(photo.toString().trim(), local_storage_key.hash_encrypt).toString());
    }
  }

  setLocalStorageLoginEmployer(_idEmployer: string, employerName: string, loginAllEmployees: string) {
    localStorage.setItem(local_storage_key._idEmployer, CryptoJS.AES.encrypt(_idEmployer.toString().trim(), local_storage_key.hash_encrypt).toString());
    localStorage.setItem(local_storage_key.employer_name, CryptoJS.AES.encrypt(employerName.toString().trim(), local_storage_key.hash_encrypt).toString());
    localStorage.setItem(local_storage_key.login_all_employees, CryptoJS.AES.encrypt(loginAllEmployees.toString().trim(), local_storage_key.hash_encrypt).toString());
  }

  sendRequestPremium(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'sendRequestPremium/', req);
  }

  sendRequestWebinar(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'sendRequestWebinar/', req);
  }

  getToken(token: string) {
    return this.http.get<any>(this.BASE_URL_SERVICE + 'getToken/' + `${token}`);
  }

  checkUserEvent(_idUser: any, eventName: string, eventData: string, insertAction: boolean, eventCheck: Array<string> = []) {

    if (eventCheck.length === 0) {
      eventCheck = [eventName];
    }

    var req = {
      _idUser: _idUser,
      eventName: eventName,
      eventData: eventData,
      eventCheck: eventCheck,
      insertEvent: insertAction === true ? 1 : 0
    }

    return this.http.post<any>(this.BASE_URL_SERVICE + 'checkUserEvent/', req);
  }

  saveEvent(_idUser: any, eventName: string, eventData: string) {

    var req = {
      _idUser: +_idUser > 0 ? +_idUser : null,
      eventName: eventName,
      eventData: eventData,
    }

    return this.http.post<any>(this.BASE_URL_SERVICE + 'saveEvent/', req);
  }

  checkUserEventDay(eventName: string, eventData: string, days: number) {

    var req = {
      _idUser: this.getIdCurrentUser(),
      eventName,
      eventData,
      days
    }

    return this.http.post<any>(this.BASE_URL_SERVICE + 'checkUserEventDay/', req);
  }

  checkEventPsychoInterview() {

    var req = {
      _idUser: this.getIdCurrentUser(),
      _idEmployer: this.getIdEmployer()
    }

    return this.http.post<any>(this.BASE_URL_SERVICE + 'checkEventPsychoInterview/', req);
  }
  checkEventJobCertificate() {

    var req = {
      _idUser: this.getIdCurrentUser()
    }

    return this.http.post<any>(this.BASE_URL_SERVICE + 'checkEventJobCertificate/', req);
  }




  checkSurveyEducation(_idUser: any) {

    var req = {
      _idUser: _idUser,
    }

    return this.http.post<any>(this.BASE_URL_SERVICE + 'checkSurveyEducation/', req);
  }

  setUserName(userName: any) {
    localStorage.setItem(local_storage_key.user_name, CryptoJS.AES.encrypt(userName?.toString().trim(), local_storage_key.hash_encrypt).toString());
  }

  setUserSurname(value: any) {
    localStorage.setItem(local_storage_key.user_surname, CryptoJS.AES.encrypt(value?.toString().trim(), local_storage_key.hash_encrypt).toString());
  }

  get isUserAdmin(): boolean {
    const userProfile = this.getUserProfile();

    return +this.getLocalUserIdentifier > 0 && (userProfile === role_name.Admin || userProfile === role_name.AdminEmployer);
  }

  get getLocalUserIdentifier(): number {

    var identifier = this.getIdCurrentUser();

    if (identifier && +identifier > 0)
      return Number.parseInt(identifier);

    return 0;
  }

  hasAccessToModule(module: profile_access_module): boolean {

    if (!PROFILE_ACCESS[this.getUserRole()]) {
      return false;
    }

    const roles = PROFILE_ACCESS[this.getUserRole()]?.roles;

    return roles.includes(module);
  }

  hasActivateModule(module: profile_access_module): boolean {

    let currentAccess: string = '';


    switch (module) {
      case profile_access_module.employer_complaint_channel:
        currentAccess = this.getAccessComplaintChannel();
        break;
      case profile_access_module.employer_psycho_interview:
        currentAccess = this.getAccessJobReference();
        break;
    }

    if (currentAccess && +currentAccess === 1)
      return true;

    return false;
  }


  get getLocalJWT(): string {
    return this.cryptoService.decryptLocalStorage(local_storage_key.user_jwt);
  }


  get getUserEventFlag(): string {

    try {
      return `${+this.cryptoService.decryptLocalStorage(local_storage_key.user_event_flag) > 0 ? 1 : 0}`;
    }
    catch {
      return '1';
    }
  }


  setLocalJWT(val: string): void {
    this.cryptoService.encryptLocalStorage(local_storage_key.user_jwt, val);

    this.refreshTokenSubject.next(val);

    // this.startRefreshTokenTimer();

  }

  async loadPermissions() {

    if (this.isLoaded === true) {
      return;
    }

    if (!this.isEmployer()) {
      this.isLoaded = true;
      return;
    }



    try {

      const res = await this.getStatusManager(+this.getIdCurrentUser()).toPromise();

      if (res.status_code === status_code.success) {

        if (res?.user_role) {
          this.setLocalUserRole(res.user_role, false)
        }

        if (res?.complaint_channel !== null) {
          this.setLocalAccessComplaintChannel(res.complaint_channel, false)
        }

        if (res?.job_reference !== null) {
          this.setLocalAccessJobReference(res.job_reference, false)
        }
      }

      this.isLoaded = true;
    } catch {
      this.isLoaded = true;
    }
  }

  // modificar: utilizar un solo servicio
  getStatusManager(_idUser) {
    return this.http.get<any>(environment.endpoint.apiemployer + 'getStatusManager/' + _idUser);
  }

  getEmployerByUser(): Observable<any> {

    return this.http.get<any>(this.BASE_URL_SERVICE + `getEmployerByUser/${this.getIdCurrentUser()}`).pipe(
      map((res) => {

        if (res.status_code === status_code.success && Array.isArray(res?.results)) {
          return Array.from(res.results).map((e: any) => { return { id: e._id, text: e.employerName } })
        }

        return of([]);
      }),
      catchError((err) => {
        return of([]);
      })
    );
  }


  setLocalRefreshJWT(val: string): void {
    this.cryptoService.encryptLocalStorage(local_storage_key.user_refresh_jwt, val);
  }

  get getLocalRefreshJWT(): string {
    return this.cryptoService.decryptLocalStorage(local_storage_key.user_refresh_jwt);
  }

  refreshToken() {

    if (!this.loggedIn())
      return of({});

    const encryptedIdUser = this.getLocalRefreshJWT ? undefined : this.cryptoService.encryptUserId(`${(+this.getIdCurrentUser() * 27) - 77}`);

    return this.http.post(this.BASE_URL_SERVICE + `refreshToken/`, {
      refreshToken: this.getLocalRefreshJWT,
      refreshType: encryptedIdUser
    })
      .pipe(
        map((res: any) => {

          if (res?.status_code === status_code.success) {

            if (res.userToken)
              this.setLocalJWT(res.userToken);

            if (res.userRefreshToken)
              this.setLocalRefreshJWT(res.userRefreshToken);

            return res;
          }

          return res;
        })
      );
  }

  refreshTokenAdminEmployer(_idEmployer: number) {

    if (!this.loggedIn())
      return of({});

    return this.http.post(this.BASE_URL_SERVICE + `refreshTokenAdminEmployer/`, {
      refreshToken: this.getLocalRefreshJWT,
      _idEmployer: _idEmployer
    })
      .pipe(
        map((res: any) => {

          if (res?.status_code === status_code.success) {

            if (res.userToken)
              this.setLocalJWT(res.userToken);

            if (res.userRefreshToken)
              this.setLocalRefreshJWT(res.userRefreshToken);

            return res;
          }

          return res;
        })
      );
  }
}
